import { Stack } from '@mui/material';

import { DividerFaded } from '@/components/common/DividerFaded';
import { HauserLogoWithTagLine } from '@/components/common/HauserLogoWithTagLine';

/** Locked brand composition for every authentication and onboarding card. */
export const AuthBrandHeader = () => (
  <Stack spacing="50px" alignItems="center" sx={{ width: '100%', flexShrink: 0 }}>
    <HauserLogoWithTagLine />
    <DividerFaded sx={{ width: 100 }} />
  </Stack>
);
